module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage"
  }, [_c('a', {
    attrs: {
      "id": "title39"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("This book is dedicated to")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATHAN CROW")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c-br"
  }, [_c('span', [_vm._v("And all the young men and women of: "), _c('br'), _vm._v("The Virginia Military Institute "), _c('br'), _vm._v("West Point "), _c('br'), _vm._v("Annapolis "), _c('br'), _vm._v("The Air Force Academy "), _c('br'), _vm._v("The Coast Guard Academy "), _c('br'), _vm._v("Norwich "), _c('br'), _vm._v("The Citadel "), _c('br'), _vm._v("and "), _c('br'), _vm._v("Texas A&M. "), _c('br'), _vm._v("These youths, past and present, have freely chosen "), _c('br'), _vm._v("to endure personal sacrifice and hardship by "), _c('br'), _vm._v("dedicating their lives to defend and uphold the "), _c('br'), _vm._v("ideals and principles that have made this nation and "), _c('br'), _vm._v("its people unlike any other.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f243d9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466824904_ded01.vue
// module id = 66
// module chunks = 0